import { List } from "@phosphor-icons/react"
import { Button } from "@tokenterminal/core/ui/button/Button"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { SearchField } from "@tokenterminal/core/ui/input/SearchField"
import BottomDrawer from "@tokenterminal/core/ui/overlays/modal/BottomDrawer"
import { Modal } from "@tokenterminal/core/ui/overlays/modal/Modal"
import { filterAndSortItems } from "@tokenterminal/core/ui/samsCombobox/searchableList/SearchableList"
import Link from "next/link"
import { useMemo, useState } from "react"

export const makeTagUrl = (tag: string, search?: string) => {
  return `/discover?category=${encodeURIComponent(tag)}${
    search ? `&search=${encodeURIComponent(search)}` : ""
  }`
}

export type Item = {
  id: string
  label: string
  href?: string
}

type MobileSidebarDrawerProps = {
  items: Item[]
  selectedKey: string
  searchPlaceholder?: string
}

const MobileSidebarDrawer = ({
  items,
  selectedKey,
  searchPlaceholder = "Search",
}: MobileSidebarDrawerProps) => {
  const [search, setSearch] = useState("")
  const [isOpen, setIsOpen] = useState(false)

  const filteredItems = useMemo(() => {
    if (search.length === 0) {
      return items
    }

    return filterAndSortItems(items, search, (item) => item.label)
  }, [items, search])

  const selectedItemText = useMemo(() => {
    const selectedItem = items.find((item) => item.id === selectedKey)
    return selectedItem?.label || "Select an item"
  }, [items, selectedKey])

  return (
    <div className="w-full lg:hidden">
      <Button
        className="w-full justify-between"
        onPress={() => setIsOpen(true)}
      >
        {selectedItemText}
        <Icon as={List} />
      </Button>
      <BottomDrawer isOpen={isOpen} setIsOpen={setIsOpen}>
        <Modal.Header title="Browse by category" />
        <div className="p-4 border-solid border-b border-border-default">
          <SearchField
            placeholder={searchPlaceholder}
            value={search}
            onChange={setSearch}
            aria-label="Search for a category"
          />
        </div>
        <div className="flex-1 overflow-y-auto">
          <div className="p-2">
            {filteredItems.map((item) => (
              <Link
                key={item.id}
                className="tt-vertical-tab"
                data-selected={selectedKey === item.id || undefined}
                onClick={() => setIsOpen(false)}
                href={makeTagUrl(item.id, search)}
                scroll={false}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      </BottomDrawer>
    </div>
  )
}

export default MobileSidebarDrawer
